/**
 * Debug logging utilities that only log in development/staging
 * Logs are completely stripped in production builds
 */

const isDev = import.meta.env.DEV;

export const debugLog = (...args: any[]) => isDev && console.log(...args);
export const debugWarn = (...args: any[]) => isDev && console.warn(...args);
export const debugError = (...args: any[]) => isDev && console.error(...args);
export const debugInfo = (...args: any[]) => isDev && console.info(...args);
